export default __webpack_public_path__ + "media/images/backgrounds/bg-3-2399189bd620643faaf5b317498e78ce.jpg";